import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { setInfluencerRef, INFLUENCER_LANDING_URL } from '../utils/influencerAttribution';

/**
 * Entrada de rastreio: app.constelabrasil.com.br/r/:code
 * Grava o código (cookie .constelabrasil.com.br + localStorage) e redireciona para a landing no site.
 */
const InfluencerRedirect: React.FC = () => {
  const { code } = useParams<{ code: string }>();

  useEffect(() => {
    const normalized = (code || '').trim().toLowerCase();
    if (normalized) {
      setInfluencerRef(normalized);
    }
    const target = normalized
      ? `${INFLUENCER_LANDING_URL}?ref=${encodeURIComponent(normalized)}`
      : INFLUENCER_LANDING_URL;
    window.location.replace(target);
  }, [code]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#EAF4F2] text-[#4A7C75]">
      <p className="text-lg font-medium">Redirecionando...</p>
    </div>
  );
};

export default InfluencerRedirect;
